import type { TextFieldProps } from '@montugroup/design-system';
import { TextField } from '@montugroup/design-system';

import type { useLatin1SafeTextFieldProps } from '../Patient/utils/latin1Safe/useLatin1SafeTextField';
import { useLatin1SafeTextField } from '../Patient/utils/latin1Safe/useLatin1SafeTextField';

export type Latin1SafeTextFieldProps = Omit<TextFieldProps, 'helperText' | 'error' | 'onChange'> &
  useLatin1SafeTextFieldProps;

export const Latin1SafeTextField = ({
  value: valueProp = '',
  onChange,
  onBlur,
  enableLatin1 = true,
  sanitizeOnPaste = true,
  maxLength,
  errorMessage,
  defaultHelperText,
  formattingHint,
  slotProps,
  ...rest
}: Latin1SafeTextFieldProps) => {
  const value = String(valueProp ?? '');

  const field = useLatin1SafeTextField({
    value,
    onChange,
    onBlur,
    enableLatin1,
    sanitizeOnPaste,
    maxLength,
    errorMessage,
    defaultHelperText,
    formattingHint,
  });
  return (
    <TextField
      {...rest}
      value={field.value}
      onChange={field.onChange}
      helperText={field.helperText}
      error={field.error}
      slotProps={{
        ...slotProps,
        htmlInput: {
          ...slotProps?.htmlInput,
          ...field.htmlInputProps,
        },
        formHelperText: {
          ...slotProps?.formHelperText,
        },
      }}
    />
  );
};
